import { GameVars } from "../../../GameVars";
import { GameConstants } from "../../../GameConstants";
import { BoardScene } from "../BoardScene";
import { Button } from "../../../utils/Utils";
import { GameManager } from "../../../GameManager";
import { AudioManager } from "../../../AudioManager";

export class OutcomeLayer extends Phaser.GameObjects.Container {

    private scaledItemsContainer: Phaser.GameObjects.Container;

    constructor(scene: Phaser.Scene) {

        super(scene);

        const background = new Phaser.GameObjects.Graphics(this.scene);
        background.fillStyle(0x495471, .7);
        background.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        background.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        background.on("pointerdown", () => {
            //
        }, this);
        this.add(background);

        this.scaledItemsContainer = new Phaser.GameObjects.Container(this.scene);
        this.scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        this.scaledItemsContainer.y = 300;
        this.scaledItemsContainer.scaleX = GameVars.scaleX;
        this.add(this.scaledItemsContainer);

        if (GameVars.winner === GameConstants.PLAYER || GameVars.mode === GameConstants.VS_PLAYER) {

            const star = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "victory_result_01");
            this.scaledItemsContainer.add(star);

            this.scene.tweens.add({
                targets: star,
                scaleX: 1.15,
                scaleY: 1.15,
                ease: Phaser.Math.Easing.Cubic.InOut,
                duration: 1000,
                yoyo: true,
                repeat: -1
            });

            const badge = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "victory_result_02");
            this.scaledItemsContainer.add(badge); 

            const piece = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", GameVars.winner === GameConstants.PLAYER ? "result_red_02" : "result_blue_02");
            this.scaledItemsContainer.add(piece);

            const ribbon = new Phaser.GameObjects.Sprite(this.scene, 0, 145, "texture_atlas_5_" + GameVars.gameData.language, "victory_result_txt");
            BoardScene.currentInstance.add.existing(ribbon);
            this.scaledItemsContainer.add(ribbon); 

            const fx = new Phaser.GameObjects.Sprite(this.scene, 0, 145, "texture_atlas_1", "victory_result_fx_01");
            fx.alpha = 0;
            BoardScene.currentInstance.add.existing(fx);
            this.scaledItemsContainer.add(fx);

            this.scene.time.addEvent({ delay: 2000, callback: () => { 
                fx.alpha = 1;
                fx.anims.play("victory_result");
            }, callbackScope: this});

            fx.on("animationcomplete", () => {
                this.scene.tweens.add({
                    targets: fx,
                    alpha: 0,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 500
                });
            }, this);

            AudioManager.playSound("victory");

        } else {

            const shadow = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "defeat_result_01");
            this.scaledItemsContainer.add(shadow);

            const badge = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "defeat_result_02");
            this.scaledItemsContainer.add(badge); 

            const piece = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "result_red_01");
            this.scaledItemsContainer.add(piece);

            const ribbon = new Phaser.GameObjects.Image(this.scene, 0, 145, "texture_atlas_5_" + GameVars.gameData.language, "defeat_result_txt");
            this.scaledItemsContainer.add(ribbon); 

            this.scene.tweens.add({
                targets: shadow,
                scaleX: 1.075,
                scaleY: 1.075,
                ease: Phaser.Math.Easing.Cubic.InOut,
                duration: 1000,
                yoyo: true,
                repeat: -1
            });

            AudioManager.playSound("defeat");
        }

        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 800,
            delay: 1000,
            onComplete: this.showReplayItems,
            onCompleteScope: this
        });
    }

    private showReplayItems(): void {

        const replayButton = new Button(this.scene, 0, 260, "texture_atlas_5_" + GameVars.gameData.language, "btn_replay", "btn_replay_on");
        replayButton.alpha = 0;
        replayButton.onDown(this.onClickReplay, this);
        this.scaledItemsContainer.add(replayButton);

        this.scene.tweens.add({
            targets: [replayButton],
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 450
        });
    }

    private onClickReplay(): void {

        GameManager.replay();

        AudioManager.playSound("click");
    }
}
